var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jump-wrap"},[_c('img',{staticClass:"img",attrs:{"width":"100%","src":_vm.imgUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }